import { Integrations as BrowserIntegrations } from '@sentry/browser';
import * as ElectronRendererIntegrations from './integrations';
export { Severity, } from '@sentry/types';
export { addGlobalEventProcessor, addBreadcrumb, captureException, captureEvent, captureMessage, configureScope, getHubFromCarrier, getCurrentHub, Hub, Scope, startTransaction, setContext, setExtra, setExtras, setTag, setTags, setUser, withScope, } from '@sentry/core';
export { BrowserClient, injectReportDialog, lastEventId, showReportDialog, } from '@sentry/browser';
export const Integrations = Object.assign(Object.assign({}, ElectronRendererIntegrations), BrowserIntegrations);
export { init, defaultIntegrations } from './sdk';
